import { Component, OnInit } from '@angular/core';
import { UserService } from '../../services/user/user.service';
import { Router  } from '@angular/router';
import { FormGroup, Validators, FormControl } from '@angular/forms';
import { limitStringLength } from 'src/utils/limitStringLength';

@Component({
  selector: 'app-password-page',
  templateUrl: './password-page.component.html',
  styleUrls: ['./password-page.component.scss']
})
export class PasswordPageComponent implements OnInit {
  public form: FormGroup;
  public loading = false;
  public errorMessage?: string;
  public attemptedSubmit = false;
  public successfullySent = false;

  constructor(
    private router: Router,
    private userService: UserService
  ) { }

  ngOnInit() {
    this.form = new FormGroup({
      password: new FormControl('', [Validators.required, Validators.minLength(8)]),
      passwordConfirm: new FormControl('', [Validators.required])
    }, this.checkPasswords);
  }

  checkPasswords(group: FormGroup) {
    const password = group.get('password').value;
    const passwordConfirm = group.get('passwordConfirm').value;

    return password === passwordConfirm ? null : { notSame: true };
  }

  get password(): FormControl { return this.form.get('password') as FormControl; }
  get passwordConfirm(): FormControl { return this.form.get('passwordConfirm') as FormControl; }

  async onSubmitClick() {
    this.errorMessage = '';
    this.attemptedSubmit = true;
    if (this.form.invalid) {
      if (!this.form.dirty) {
        this.form.markAsDirty();
      }
      return;
    }
    if (this.successfullySent) {
      return;
    }
    const password = this.password.value;
    const passwordConfirm = this.passwordConfirm.value;
    this.loading = true;
    try {
      const response = await this.userService.changePassword(password, passwordConfirm);
      if (response === true) {
        this.successfullySent = true;
      } else {
        throw new Error("Server returned unexpected response: " + limitStringLength(JSON.stringify(response), 100));
      }
    } catch(err) {
      this.loading = false;
      this.attemptedSubmit = false;
      this.errorMessage = ((err && err.message ? err.message : err) || "Unknown error").toString();
    }
    this.loading = false;
  }

}
